import React, { useContext } from 'react';
import usePostSideFilters from '../../../hooks/home/usePostSideFilters';
import { Language } from '../../../App';
import { 
  MdOutlineDynamicFeed, 
  MdOutlineArticle, 
  MdOutlinePoll, 
  MdOutlineSensors, 
  MdOutlineMedicalServices 
} from "react-icons/md";

/* ── Matching per-type accent config from PostSideFilters (On this page) ── */
const TYPE_CONFIG = {
  all: {
    color: "#00BADA",
    light: "#E8FBFF",
    border: "#BCEEFA",
    shadow: "rgba(0, 186, 218, 0.22)",
  },
  posts: {
    color: "#3B82F6",
    light: "#EFF6FF",
    border: "#BFDBFE",
    shadow: "rgba(59, 130, 246, 0.22)",
  },
  poll: {
    color: "#F59E0B",
    light: "#FFFBEB",
    border: "#FDE68A",
    shadow: "rgba(245, 158, 11, 0.22)",
  },
  webinar: {
    color: "#EF4444",
    light: "#FEF2F2",
    border: "#FECACA",
    shadow: "rgba(239, 68, 68, 0.22)",
  },
  "clinical-image": {
    color: "#10B981",
    light: "#ECFDF5",
    border: "#A7F3D0",
    shadow: "rgba(16, 185, 129, 0.22)",
  },
};

const getConfig = (itemType) => TYPE_CONFIG[itemType] || TYPE_CONFIG.all;

const ICON_MAP = {
  all: MdOutlineDynamicFeed,
  posts: MdOutlineArticle,
  poll: MdOutlinePoll,
  webinar: MdOutlineSensors,
  "clinical-image": MdOutlineMedicalServices,
};

const FeedMobileFilter = () => {
  const { lang } = useContext(Language);
  const { handleType, type, typesData } = usePostSideFilters();

  const handleTabClick = (tabType) => {
    handleType(tabType);
  };

  return (
    <nav
      className="d-flex flex-nowrap mb-2 scroll-hide overflow-hidden d-xl-none align-items-center justify-content-between"
      style={{
        width: '100%',
        top: '68px',
        zIndex: 10,
        position: 'sticky',
        borderRadius: "9999px",
        background: "linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 253, 255, 0.96) 100%)",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        border: "1px solid #D7E0EA",
        padding: "4px 5px",
        boxShadow: "0 8px 24px rgba(0, 186, 218, 0.06), 0 2px 6px rgba(0, 0, 0, 0.02)",
      }}
    >
      {typesData.map(({ text, type: itemType }) => {
        const isActive = itemType === type;
        const label = lang?.[text] || text.replace('_', ' ');
        const cfg = getConfig(itemType);
        const IconEl = ICON_MAP[itemType] || MdOutlineDynamicFeed;

        return (
          <button
            key={itemType}
            onClick={() => handleTabClick(itemType)}
            className="d-inline-flex align-items-center justify-content-center rounded-pill cursor"
            style={{
              height: "36px",
              padding: isActive ? "0 14px" : "0 9px",
              minWidth: isActive ? "auto" : "36px",
              background: isActive ? cfg.light : "transparent",
              border: `1px solid ${isActive ? cfg.border : "transparent"}`,
              color: isActive ? cfg.color : "#64748B",
              boxShadow: isActive ? `0px 2px 10px ${cfg.shadow}` : "none",
              fontSize: "12.5px",
              fontWeight: isActive ? "700" : "500",
              fontFamily: "'Onest', sans-serif",
              transition: "all 0.32s cubic-bezier(0.34, 1.25, 0.64, 1)",
              lineHeight: 1,
              outline: "none",
              userSelect: "none",
              WebkitTapHighlightColor: "transparent",
            }}
            role="button"
            aria-label={`Filter by ${label}`}
            aria-current={isActive ? "true" : undefined}
          >
            <span
              className="d-inline-flex align-items-center justify-content-center flex-shrink-0"
              style={{
                lineHeight: 1,
                transform: isActive ? "scale(1.06)" : "scale(1)",
                transition: "transform 0.25s ease",
              }}
            >
              <IconEl
                size={18}
                style={{
                  color: isActive ? cfg.color : cfg.color,
                  opacity: isActive ? 1 : 0.85,
                  transition: "color 0.25s ease, opacity 0.25s ease",
                }}
              />
            </span>
            <span
              style={{
                display: "inline-block",
                maxWidth: isActive ? "140px" : "0px",
                opacity: isActive ? 1 : 0,
                transform: isActive ? "translateX(0) scale(1)" : "translateX(-6px) scale(0.85)",
                marginLeft: isActive ? "6px" : "0px",
                overflow: "hidden",
                whiteSpace: "nowrap",
                color: cfg.color,
                fontWeight: 700,
                transition: "max-width 0.32s cubic-bezier(0.34, 1.25, 0.64, 1), opacity 0.25s ease, transform 0.25s ease, margin-left 0.3s ease",
                lineHeight: 1,
              }}
            >
              {label}
            </span>
          </button>
        );
      })}
    </nav>
  );
};

export default FeedMobileFilter;